import * as THREE from 'three';

export interface Cullable {
  mesh: THREE.Object3D;
  distSq: number;
}

/** 
 * Phase 10: Aggressive LOD Culling
 * Checks distance to camera and hides objects far away to reduce draw calls.
 */
export class FpsLODCuller {
  private culls: Cullable[] = [];
  private seen = new Set<THREE.Object3D>();
  private checkAcc = 0;
  
  public add(mesh: THREE.Object3D, maxDist: number) {
    if (this.seen.has(mesh)) return;
    this.seen.add(mesh);
    this.culls.push({ mesh, distSq: maxDist * maxDist });
  }

  public collectDecorative(root: THREE.Object3D, defaultDist = 120): number {
    let added = 0;
    root.traverse((child) => {
      if (child === root || child.userData.decorative !== true) return;
      if (child.parent?.userData.decorative === true) return;
      const dist = typeof child.userData.cullDistance === 'number' ? child.userData.cullDistance : defaultDist;
      const before = this.culls.length;
      this.add(child, dist);
      if (this.culls.length > before) added++;
    });
    return added;
  }

  public update(dt: number, cameraPos: THREE.Vector3) {
    this.checkAcc += dt;
    // Throttle culling checks so we don't iterate everything every frame
    if (this.checkAcc < 0.25) return;
    this.checkAcc = 0;

    for (const c of this.culls) {
      // Very simple distance-based culling
      const dx = c.mesh.position.x - cameraPos.x;
      const dz = c.mesh.position.z - cameraPos.z;
      const dSq = dx * dx + dz * dz;
      
      c.mesh.visible = dSq <= c.distSq;
    }
  }
}
